﻿module.exports = (function ($, bootstrap) {
    return {
        alignTitleHeights: function () {
            $('.collectionSection__title').height('auto');
            // Check the current breakpoint.
            var currentBreakPoint = (window.innerWidth < 767 ? 0 : (window.innerWidth < 1023 ? 1 : (window.innerWidth < 1200 ? 2 : 3)));
            // Reset title height to match highest.
            if (currentBreakPoint == 3) {
				$('.collectionSection .collectionSection__title').equalizeHeights(4);
                $('.glossaries .collectionSection__title').equalizeHeights(4);
            } else if (currentBreakPoint == 2) {
				$('.collectionSection .collectionSection__title').equalizeHeights(3);
                $('.glossaries .collectionSection__title').equalizeHeights(3);
            } else if (currentBreakPoint == 1) {
				$('.collectionSection .collectionSection__title').equalizeHeights(2);
                $('.glossaries .collectionSection__title').equalizeHeights(2);
            }
        },
        init: function () {

            var self = this;
            self.alignTitleHeights();

            $(window).resize(function () {
                // Reset height
                self.alignTitleHeights();
            });

            $(document).on("click", ".collectionSection__row__removeCollection", function () {
                    $(this).parent().find(".collectionSection__main").hide();
                    $(this).parent().find(".collectionSection__row__removeCollection").hide();
                    $(this).parent().find(".collectionSection__confirmation").show();
                });
            $(document).on("click", ".formSection__button_cancel_delete", function () {
                    $(this).closest(".collectionSection__item").find(".collectionSection__main").show();
                    $(this).closest(".collectionSection__item").find(".collectionSection__row__removeCollection").show();
                    $(this).closest(".collectionSection__item").find(".collectionSection__confirmation").hide();
                });
            $(document).on("click", ".formSection__button_delete", function () {
                    var that = $(this);
                    var collectionId = $(this).closest(".collectionSection__item").find(".collectionSection__row__removeCollection").data("collection-id");
                    var glossaryId = $(this).closest(".collectionSection__item").find(".collectionSection__row__removeCollection").data("glossary-id");
                    if (collectionId)
                    {
                        $.ajax({
                            url: '/umbraco/surface/Member/RemoveCollection/',
                            type: 'POST',
                            traditional: true,
                            dataType: 'json',
                            data: {
                                collectionId: collectionId
                            },
                            success: function (data) {
                                $(that).closest(".collectionSection__item").remove();
                            },
                            error: function (result) {
                            },
                            complete: function () {
                                self.alignTitleHeights();
                            }
                        });
                    }

                    if (glossaryId) {
                        $.ajax({
                            url: '/umbraco/surface/Member/RemoveGlossary/',
                            type: 'POST',
                            traditional: true,
                            dataType: 'json',
                            data: {
                                glossaryId: glossaryId
                            },
                            success: function (data) {
                                $(that).closest(".collectionSection__item").remove();
                            },
                            error: function (result) {
                            },
                            complete: function () {
                                self.alignTitleHeights();
                            }
                        });
                    }
                    
                });
            $(document).on("click", ".collectionSection__item__new__link", function () {
                    $(this).closest(".collectionSection__item").find(".collectionSection__item__new__form").show();
                    $(this).closest(".collectionSection__item").find(".collectionSection__item__new__link").hide();
                    $(this).closest(".collectionSection__item").find(".collectionSection__confirmation__caption input").val("").focus();
                });
            $(document).on("click", ".collectionSection__item__new__form .formSection__button__cancel", function () {
                    $(this).closest(".collectionSection__item").find(".collectionSection__item__new__form").hide();
                    $(this).closest(".collectionSection__item").find(".collectionSection__item__new__link").show();
                    $(this).closest(".collectionSection__item").find(".collectionSection__confirmation__caption input").val("");
                });
            $(document).on("click",".collectionSection__item__new__form .formSection__button_create", function () {
                    var that = $(this);
                    var name = $(this).closest(".collectionSection__item").find(".collectionSection__item__new__form .collectionSection__confirmation__caption input:first").val();
                    if (name.trim().length === 0) {
                        return false;
                    }
                    // Check first to see if this is a new glossary
                    if ($(this).data("glossary")) {
                        $.ajax({
                            url: '/umbraco/surface/Member/AddGlossary/',
                            type: 'POST',
                            traditional: true,
                            dataType: 'json',
                            data: {
                                glossaryName: name
                            },
                            success: function (data) {
                                if (data.result === "success") {
                                    var newItem = $(that).closest(".collectionSection__row")
                                        .find(".collectionSection__item__template")
                                        .clone();
                                    $(newItem).removeClass("collectionSection__item__template").show();
                                    var href = $(newItem).find(".collectionSection__title a:first").attr("href") + data.newGuid;
                                    $(newItem).find(".collectionSection__title a:first").attr("href", href);
                                    $(newItem).find(".collectionSection__title a:first span").html(name);
                                    $(newItem).find(".collectionSection__main:first").attr("href", href);
                                    $(newItem).find(".collectionSection__row__removeCollection:first").attr("data-collection-id", data.newGuid);
                                    $(newItem).insertBefore($(that).closest(".collectionSection__item__new"));
                                    $(".collectionSection__item__new__form .formSection__button__cancel").trigger("click");
                                } else {
                                    alert("An error occurred and we could not complete the requested action.");
                                }
                            },
                            error: function (result) {
                            },
                            complete: function () {
                                self.alignTitleHeights();
                            }
                        });
                    }
                    else
                    {
                        // create the normal collections
                        $.ajax({
                            url: '/umbraco/surface/Member/AddCollection/',
                            type: 'POST',
                            traditional: true,
                            dataType: 'json',
                            data: {
                                collectionName: name
                            },
                            success: function (data) {
                                if (data.result === "success") {
                                    var newItem = $(that).closest(".collectionSection__row")
                                        .find(".collectionSection__item__template")
                                        .clone();
                                    $(newItem).removeClass("collectionSection__item__template").show();
                                    var href = $(newItem).find(".collectionSection__title a:first").attr("href") + data.newGuid;
                                    $(newItem).find(".collectionSection__title a:first").attr("href", href);
                                    $(newItem).find(".collectionSection__title a:first span").html(name);
                                    $(newItem).find(".collectionSection__main:first").attr("href", href);
                                    $(newItem).find(".collectionSection__row__removeCollection:first").attr("data-collection-id", data.newGuid);
                                    $(newItem).insertBefore($(that).closest(".collectionSection__item__new"));
                                    $(".collectionSection__item__new__form .formSection__button__cancel").trigger("click");
                                } else {
                                    alert("An error occurred and we could not complete the requested action.");
                                }
                            },
                            error: function (result) {
                            },
                            complete: function () {
                                self.alignTitleHeights();
                            }
                        });
                    }
                    
                });
            $(".collectionSection__item__new__form input").on("keyup",
                function(e) {
                    if (e.keyCode === 13) {
                        $(this).closest(".collectionSection__item__new__form").find(".formSection__button_create").trigger("click");
                    }
                });
        }
    };
});